function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
import axios from 'axios';
moment.locale('ja');
export default {
  props: {
    'url': String
  },
  data: function data() {
    return {
      year: 0,
      month: 0,
      today: '0000-00-00',
      resData: [],
      filterData: [],
      daysCells: [],
      dayOfTheWeek: ['日', '月', '火', '水', '木', '金', '土'],
      debugFlg: true
    };
  },
  created: function created() {
    this.getData();
    this.today = moment().format('YYYY-MM-DD');
    this.createCalendar();
  },
  methods: {
    debug: function debug(e) {
      if (this.debugFlg) {
        console.log(e);
        return e;
      }
    },
    getData: function () {
      var _getData = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof this.url === 'undefined')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return axios.get(this.url);

              case 5:
                response = _context.sent;
                this.resData = response.data;
                this.resData = this.resData.sort(function (a, b) {
                  if (moment(a.close) < moment(b.close)) return -1;
                  if (moment(a.close) > moment(b.close)) return 1;
                  return 0;
                });
                this.resData = this.resData.sort(function (a, b) {
                  if (moment(a.open) < moment(b.open)) return -1;
                  if (moment(a.open) > moment(b.open)) return 1;
                  return 0;
                });
                this.filterAct();
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", false);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 12]]);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }(),
    setClass: function setClass(e) {
      var _this = this;

      var className = '';
      this.filterData.forEach(function (item, key) {
        var open = item.open;
        var close = item.close;
        if (close === '') close = item.open;
        console.log(_this.today);
        console.log(open);
        console.log(close);
        if (Number(moment(open).format('YYYYMM')) > Number(moment(_this.today).format('YYYYMM')) && Number(moment(close).format('YYYYMM')) > Number(moment(_this.today).format('YYYYMM'))) return false;

        if (Number(moment(open).format('YYYYMM')) < Number(moment(_this.today).format('YYYYMM')) && Number(moment(close).format('YYYYMM')) === Number(moment(_this.today).format('YYYYMM'))) {
          open = moment(_this.today).startOf('month');
        } else if (Number(moment(open).format('YYYYMM')) === Number(moment(_this.today).format('YYYYMM')) && Number(moment(close).format('YYYYMM')) < Number(moment(_this.today).format('YYYYMM'))) {
          close = moment(_this.today).endOf('month');
        } else if (Number(moment(open).format('YYYYMM')) < Number(moment(_this.today).format('YYYYMM')) && Number(moment(close).format('YYYYMM')) < Number(moment(_this.today).format('YYYYMM'))) {
          open = moment(_this.today).startOf('month');
          close = moment(_this.today).endOf('month');
        }

        if (Number(moment(open).format('D')) <= Number(e) && Number(e) <= Number(moment(close).format('D'))) {
          console.log(item.status);
          console.log(e);

          if (_this.url.indexOf("library") !== -1) {
            switch (item.status) {
              case "9:00～20:00":
                className = "-orange";
                break;

              case "9:00～17:00":
                className = "-yellow";
                break;

              case "9:00～21:00":
                className = "-blue";
                break;

              case "8:30～17:00":
                className = "-pink";
                break;

              case "8:30～21:00":
                className = "-green";
                break;

              case "10:00～17:00":
                className = "-pink02";
                break;

              case "休館日":
                className = "-red";
                break;

              default:
                className = "-white";
                break;
            }
          } else if (_this.url.indexOf("plaza") !== -1) {
            switch (item.status) {
              case '9:00～20:00':
                className = '-orange';
                break;

              case '9:00～17:00':
                className = '-yellow';
                break;

              case '9:00～12:30':
                className = '-blue';
                break;

              case '9:00～18:00':
                className = '-pink';
                break;

              case '9:00～19:00':
                className = '-green';
                break;

              case '9:00～21:00':
                className = '-pink02';
                break;

              case '閉室日':
                className = '-red';
                break;

              default:
                className = '-white';
                break;
            }
          }
        } else {
          return false;
        }
      });

      if (className === '') {
        className = '-white';
      }

      return className;
    },
    filterAct: function filterAct() {
      var _this2 = this;

      this.filterData = this.resData.filter(function (item, key) {
        if (moment(item.open).format('YYYY-MM') === moment(_this2.today).format('YYYY-MM') || moment(item.close).format('YYYY-MM') === moment(_this2.today).format('YYYY-MM')) {
          return item;
        }
      });
    },
    createCalendar: function createCalendar() {
      this.year = moment(this.today).format('YYYY');
      this.month = moment(this.today).format('M');
      this.filterAct();
      var monthEnd = Number(moment(this.today).endOf('month').format('DD'));
      var monthStartDayOfWeek = Number(moment(this.today).startOf('month').format('d'));
      var row = Math.ceil((monthStartDayOfWeek + monthEnd) / 7);
      var monthDays = [];
      var day = 1;

      for (var i = 1; i <= row * 7; i++) {
        if (monthStartDayOfWeek < i && i <= monthEnd + monthStartDayOfWeek) {
          monthDays = [].concat(_toConsumableArray(monthDays), [{
            'num': String(day)
          }]);
          day++;
        } else {
          monthDays = [].concat(_toConsumableArray(monthDays), [{
            'num': ''
          }]);
        }
      }

      var newArr = [];

      for (var _i = 0; _i < row * 7;) {
        newArr = [].concat(_toConsumableArray(newArr), [[monthDays[_i], monthDays[_i + 1], monthDays[_i + 2], monthDays[_i + 3], monthDays[_i + 4], monthDays[_i + 5], monthDays[_i + 6]]]);
        _i = _i + 7;
      }

      this.daysCells = newArr;
    },
    moveCalendar: function moveCalendar(e) {
      if (e === 'before') {
        this.today = moment(this.today).subtract(1, 'months').format('YYYY-MM-DD');
      } else if (e === 'next') {
        this.today = moment(this.today).add(1, 'months').format('YYYY-MM-DD');
      } else {
        return;
      }

      this.createCalendar();
    },
    beforeMonth: function beforeMonth() {
      if (Number(this.month) - 1 > 0) {
        return Number(this.month) - 1;
      } else {
        return 12;
      }
    },
    nextMonth: function nextMonth() {
      if (Number(this.month) + 1 < 13) {
        return Number(this.month) + 1;
      } else {
        return 1;
      }
    }
  }
};